import { cherrePropertyUseHierarchical } from 'src/const/lookups';
import numberWithCommas from 'src/utils/numberWithCommas';
import * as T from './types';
import { TaxAssessorsQuery } from './recoil/__generated__';

export const taxAssessorToDealData = (
  data: TaxAssessorsQuery
): Omit<T.SingleDealModalProps, 'stages' | 'leads' | 'variation'> => {
  const taxAssessor = data.tax_assessor_v2[0];

  const mappedCode = taxAssessor.property_use_code_mapped;

  const reisAttributes =
    taxAssessor.cherre_address__property_address?.[0]
      ?.reis_property_attributes__address?.[0];

  const address = taxAssessor.address || '';
  const city = taxAssessor.city || '';
  const state = taxAssessor.state || '';
  const country = 'US';
  const zip = taxAssessor.zip || '';

  const propertyUseCodeMapped = cherrePropertyUseHierarchical.find(
    (a) => a.lookup_code === mappedCode
  )?.lookup_value;

  const propertyAddress = `${address}, ${city}, ${state} ${zip}`;
  const propertyType = reisAttributes?.sector || propertyUseCodeMapped || '--';
  const buildingArea = `${
    numberWithCommas(reisAttributes?.sizesqft || taxAssessor.building_sq_ft) ||
    '--'
  }`;
  const landArea = taxAssessor.lot_size_acre?.toString() || '--';
  const zoning = taxAssessor.zone_code || '--';
  const yearBuilt =
    reisAttributes?.yearbuilt?.toString() ||
    taxAssessor.year_built?.toString() ||
    '--';

  const numberOfUnits =
    reisAttributes?.sizeunit?.toString() ||
    taxAssessor.units_count?.toString() ||
    '--';

  return {
    propertyAddress,
    propertyType,
    buildingArea,
    landArea,
    zoning,
    longitude: String(taxAssessor?.longitude || ''),
    latitude: String(taxAssessor?.latitude || ''),
    zipCode: zip,
    city,
    state,
    country,
    taxAssessorId: taxAssessor.tax_assessor_id || 0,
    parcelId: taxAssessor.cherre_parcel_id || '',
    yearBuilt,
    numberOfUnits,
    unitType: 'sqft',
    isMultiFam: '',
    numberOfAppartments: numberOfUnits,
  };
};
